export default async function ScrollUp(e) {
  setTimeout(() => {
    e.target.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, 300);
}
